export default {
  Extract: {
    CHECKING: 'Checking for extracts',
    STOPPED: 'Sync with sources',
    EXTRACTING: 'Syncing...',
    COMPLETE: 'Sync with sources',
  },
};
